import {get,post} from '../utils/request'

// 校领导
// 素养分布等级图
export const distributionChart = (data) => post('https://yingde_api.ydassess.com/health/public/unit/grade/dim_field/rank/compare',data)

// 获取学校学生与所在市的数据对比数据
export const dataContrastChart = (data) => post('https://yingde_api.ydassess.com/health/public/units/grade/dim_field/compare',post)

// 获取学校学生与所在省、全国的数据对比图
export const thirdLevelChart = (params) => post('https://yingde_api.ydassess.com/health/public/units/grade/dim_field/compare',post)

// 区领导
export const allData = (data) => post('https://yingde_api.ydassess.com/health/public/unit/grade/dim_field/gender/compare',data)

// 获取多单位对比雷达图  区县大屏
export const radarChart = (data) => post('https://yingde_api.ydassess.com/health/public/units/grade/dim_field/radar/compare',data)

// 获取当前登陆者详细信息
export const info = (url,params) => get(url,params)


// WEBPACK FOOTER //
// ./src/api/lagerScreen.js